<footer class="footer layout horizontal center middle">
    {{'FOOTER.CONTENT'|translate}}
</footer>